import {useEffect, useState, useContext} from 'react'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import * as Yup from 'yup'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import './index.css'
import clsx from 'clsx'
import secureLocalStorage from 'react-secure-storage'
import ThemeColors from './ThemePref'
import Select, {components} from 'react-select'
import {useThemeMode} from '../../../_metronic/partials'
import {useLocation, useNavigate} from 'react-router-dom'
import usePostApi from '../custom_hooks/usePostApi'
import {UseToast} from '../useToast'
import {toast} from 'react-toastify'
import AppContext from '../../AppContext'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {DataCenters} from './steps/DataCenters'
import {PrimaryOutlineButton} from '../../ui/PrimaryOutlineButton'
import {LightOutlineButton} from '../../ui/LightOutlineButton'
import Swal from 'sweetalert2'
import {useAuth} from '../auth'

type Data = {
  pod_business_name: string
  pod_brand_name: string
  pod_industry_id: number | string
  pod_team_size: number
  pod_description: string
  pod_country_code: string
  pod_website_url: string
  dateFormat: string
  timeZone: string
  pod_pref_color: string
  pod_currency_code: string
  data_center_id: string
}

interface UserInfo {
  user_id: string | undefined
}

function CustomWizardNew({
  addNewPod = () => {},
  closeModal = () => {},
  fetchPODsList = () => {},
  postLoading = false,
}: any) {
  const {currentUser} = useAuth()
  const {podsData} = useContext(AppContext)
  const {mode} = useThemeMode()
  const userInfo = secureLocalStorage.getItem('user_info') as Partial<UserInfo> | null
  const user_id: any = userInfo?.user_id
  const [currentStep, setCurrentStep] = useState<number>(0)
  const [podData, setPodData] = useState({pod_code: '', pod_id: ''})
  const [data, setData] = useState<Data>({
    pod_business_name: '',
    pod_brand_name: '',
    pod_industry_id: '',
    pod_team_size: -1,
    pod_description: '',
    pod_country_code: '',
    pod_website_url: '',
    dateFormat: '',
    timeZone: '',
    pod_pref_color: '#da0032',
    pod_currency_code: '',
    data_center_id: '',
  })
  const set2ndIndex = () => {
    setCurrentStep(1)
  }

  const set3rdIndex = () => {
    setCurrentStep(2)
  }

  const [isPodAdded, setIsPodAdded] = useState(false)

  const handleCloseModalAndReloadPods = () => {
    if (currentStep === 2 && isPodAdded) {
      closeModal()
      fetchPODsList(false, podsData === null)
    } else {
      closeModal()
    }
  }

  const addPod = async () => {
    const formData: any = new FormData()
    formData.append('pod_brand_name', data.pod_brand_name)
    formData.append('pod_business_name', data.pod_business_name)
    formData.append('pod_country_code', data.pod_country_code)
    formData.append('pod_description', data.pod_description)
    formData.append('pod_industry_id', data.pod_industry_id)
    formData.append('pod_team_size', data.pod_team_size)
    formData.append('created_by', user_id)
    formData.append('pod_pref_color', data.pod_pref_color)
    formData.append('pod_date_format', data.dateFormat)
    formData.append('pod_timezone', data.timeZone)
    formData.append('url', data.pod_website_url)
    formData.append('pod_currency_code', data.pod_currency_code)
    formData.append('data_center_id', data.data_center_id)
    formData.append('email', currentUser?.email || '')

    const response = await addNewPod(formData)
    // await fetchPODsList(false, podsData === null)
    // closeModal()

    if (response?.status === true) {
      closeModal()
      // toast.dismiss()
      // setPodData({pod_code: response?.data?.pod_code, pod_id: response?.data?.pod_id})
      // setIsPodAdded(true)
      Swal.fire({
        icon: 'success',
        title:
          '<h2 class="mb-2" style="font-weight: 600; font-family: Urbanist">POD Created Successfully!</h2>',
        html: `
    <p class="mb-1" style="font-size: 1rem; color: #333; font-family: Urbanist">
      Congratulations. Your POD has been created successfully.
    </p>
    <p style="font-size: 1rem; color: #333; font-family: Urbanist">
      <span style="font-weight: 500; font-family: Urbanist">Your POD ID:</span>
      <span style="font-weight: 600; font-family: Urbanist">${response?.data?.pod_code}</span>
    </p>
  `,
        confirmButtonText: 'Continue',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          confirmButton: `btn btn-sm bg-${
            mode === 'dark' ? 'secondary' : 'white'
          } btn-outline border-primary text-primary btn-active-light-primary`,
          popup: 'swal2-custom-popup',
        },
      }).then(() => {
        fetchPODsList()
      })

      return null
    } else if (response.status_code === 'SC0135') {
      UseToast(
        response.status_message,
        {
          position: 'bottom-right',
          theme: 'colored',
          autoClose: false,
        },
        'error'
      )
      // console.log(response.status_message)
    }
  }

  // <Step3
  //   data={data}
  //   setData={setData}
  //   isPodAdded={isPodAdded}
  //   podData={podData}
  //   setCurrentStep={setCurrentStep}
  //   key='step_3'
  // />,

  const steps = [
    <Step1 set2ndIndex={set2ndIndex} data={data} setData={setData} key='step_1' />,
    <Step2 set3rdIndex={set3rdIndex} data={data} setData={setData} key='step_2' />,
    <DataCenters
      data={data}
      setData={setData}
      isPodAdded={isPodAdded}
      podData={podData}
      fetchPODsList={fetchPODsList}
      key={'step_4'}
    />,
  ]

  const nextStep = async () => {
    if (currentStep === 0) {
      const element = document.getElementById('verify-sign-up-btn')
      if (element) {
        element.click()
      }
    } else if (currentStep === 1) {
      const element = document.getElementById('step_2_submit')
      if (element) {
        element.click()
      }
    }
    // else if (currentStep === 2) {
    //   const element = document.getElementById('step_3_submit')
    //   if (element) {
    //     element.click()
    //   }
    // }
    else {
      const totalSteps = steps.length - 1
      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1)
      } else if (!data.data_center_id) {
        return UseToast(
          'Please select a data center before proceeding.',
          {
            position: 'bottom-right',
            autoClose: false,
            theme: 'colored',
          },
          'error'
        )
      } else {
        addPod()
      }
    }
  }

  const prevStep = (): void => {
    if (currentStep !== 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  const {pathname} = useLocation()

  let buttonText: string
  if (currentStep === 1) {
    buttonText = 'Continue'
  } else if (currentStep === 2) {
    buttonText = 'Create POD'
  } else {
    buttonText = 'Continue'
  }

  return (
    <div className='card py-0 overflow-auto'>
      <div className='w-100 m-auto'>
        <div className='d-flex justify-content-between mb-10 mt-1'>
          <h3 className='fs-3 fw-semibold'>Create New POD</h3>
          {pathname !== '/first-pod-setup' ? (
            <LightOutlineButton
              type='button'
              className='d-block btn-icon'
              onClick={handleCloseModalAndReloadPods}
              // onClick={() => closeModal()}
              // onClick={() => (currentStep === 3 ? window.location.reload() : closeModal())}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </LightOutlineButton>
          ) : null}
        </div>
        <div className='w-100 row m-0'>
          <div className='col-lg-5 p-0 mb-5 mb-lg-0'>
            <div className=''>
              <div className='d-flex'>
                <div
                  style={{borderRadius: '10px'}}
                  className={clsx(
                    'w-40px h-40px btn d-flex justify-content-center align-items-center',
                    {
                      'btn-primary': currentStep === 0,
                      'btn-light-primary': currentStep !== 0,
                    }
                  )}
                >
                  {currentStep === 0 ? 1 : <i className='stepper-check fas fa-check'></i>}
                </div>
                <div className='ms-5'>
                  <h6
                    className={clsx('mb-0 fw-semibold', {
                      'text-muted': currentStep >= 0,
                    })}
                  >
                    Step 1
                  </h6>
                  <p
                    className={clsx('fs-6 mb-0', {
                      'text-muted': currentStep >= 0,
                    })}
                  >
                    Company & Brand
                  </p>
                </div>
              </div>
              <div
                style={{marginLeft: '19px'}}
                className='h-30px border-left border-dashed border-muted border-top-0 border-bottom-0 border-right-0 border-left-1'
              ></div>
              <div className='d-flex'>
                <div
                  style={{borderRadius: '10px'}}
                  className={clsx(
                    'w-40px h-40px btn d-flex justify-content-center align-items-center',
                    {
                      'btn-primary': currentStep === 1,
                      'btn-light-primary': currentStep !== 1,
                    }
                  )}
                >
                  {currentStep > 1 ? <i className='stepper-check fas fa-check'></i> : 2}
                </div>
                <div className='ms-5'>
                  <h6
                    className={clsx('mb-0 fw-semibold', {
                      'text-muted': currentStep >= 1,
                    })}
                  >
                    Step 2
                  </h6>
                  <p
                    className={clsx('fs-6 mb-0', {
                      'text-muted': currentStep >= 1,
                    })}
                  >
                    Industry & Team
                  </p>
                </div>
              </div>
              {/* Add more steps here */}
              <div
                style={{marginLeft: '19px'}}
                className='h-30px border-left border-dashed border-muted border-top-0 border-bottom-0 border-right-0 border-left-1'
              ></div>
              <div className='d-flex'>
                <div
                  style={{borderRadius: '10px'}}
                  className={clsx(
                    'w-40px h-40px btn d-flex justify-content-center align-items-center',
                    {
                      'btn-primary': currentStep === 2,
                      'btn-light-primary': currentStep !== 2,
                    }
                  )}
                >
                  {currentStep > 2 ? <i className='stepper-check fas fa-check'></i> : 3}
                </div>
                <div className='ms-5'>
                  <h6
                    className={clsx('mb-0 fw-semibold', {
                      'text-muted': currentStep >= 2,
                    })}
                  >
                    Step 3
                  </h6>
                  <p
                    className={clsx('fs-6 mb-0', {
                      'text-muted': currentStep > 1,
                    })}
                  >
                    Data Center
                  </p>
                </div>
              </div>

              {/* <div className='ms-7 h-30px border-left border-dashed border-muted border-top-0 border-bottom-0 border-right-0 border-left-1'></div>
              <div className='d-flex'>
                <div
                  style={{borderRadius: '10px'}}
                  className={clsx(
                    'w-40px h-40px btn d-flex justify-content-center align-items-center',
                    {
                      'btn-primary': currentStep === 3,
                      'btn-light-primary': currentStep !== 3,
                    }
                  )}
                >
                  {currentStep > 3 ? <i className='stepper-check fas fa-check'></i> : 4}
                </div>
                <div className='ms-5'>
                  <h6
                    className={clsx('mb-0 fw-semibold', {
                      'text-muted': currentStep >= 3,
                    })}
                  >
                    Step 4
                  </h6>
                  <p
                    className={clsx('fs-6 mb-0', {
                      'text-muted': currentStep >= 3,
                    })}
                  >
                    Data Center
                  </p>
                </div>
              </div> */}
            </div>
          </div>
          <div className='col-lg-7 p-0 m-0'>{steps[currentStep]}</div>
        </div>

        <div className='w-100 d-flex justify-content-end mt-5'>
          <div className='mr-2'>
            {currentStep > 0 && !isPodAdded && (
              <LightOutlineButton onClick={prevStep} type='button' className='me-3'>
                <KTIcon iconName='arrow-left' className='fs-4 me-1' />
                Previous
              </LightOutlineButton>
            )}
          </div>

          <div className='mb-1'>
            {!isPodAdded || currentStep < 2 ? (
              <PrimaryOutlineButton type='submit' onClick={nextStep} loading={postLoading}>
                {postLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    {buttonText}
                    <KTIcon iconName='arrow-right' className='fs-3 text-primary ms-1' />
                  </>
                )}
              </PrimaryOutlineButton>
            ) : (
              // <button
              //   type='submit'
              //   className='btn btn-sm btn-light-primary'
              //   onClick={nextStep}
              //   disabled={postLoading}
              // >
              //   {postLoading ? (
              //     <span className='indicator-progress' style={{display: 'block'}}>
              //       Please wait...{' '}
              //       <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              //     </span>
              //   ) : (
              //     <>
              //       {buttonText}
              //       <KTIcon iconName='arrow-right' className='fs-3 ms-1' />
              //     </>
              //   )}
              // </button>
              <button
                onClick={handleCloseModalAndReloadPods}
                type='button'
                className='btn btn-sm btn-light'
              >
                {/* <KTIcon iconName='arrow-left' className='fs-4 me-1' /> */}
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomWizardNew
